export const AUTH_KEYS = {
  ACCOUNT_CREATION: 'account_creation',
  ACCOUNT_PAGE: 'account_page',
  ACCOUNT_INFO: 'account_info',
  ACCOUNT_INFO_REGISTER: 'account_info_register',
  TRANS_ACCOUNT_INFO_REGISTER: 'trans_account_info_register',
  ACHIEVEMENTS: 'achievements',
  CASE_MANAGEMENT: 'case_management',
  CASE_MANAGEMENT_DETAILS: 'case_management_details',
  CHANGE_PASSWORD: 'change_password',
  COLLECTION_SCHEDULE_MANAGEMENT: 'collection_schedule_management',
  COLLECTION_SCHEDULE_LIST: 'collection_schedule_list',
  COLLECTION_SCHEDULE_DETAILS: 'collection_schedule_details',
  CONTRACT_MANAGEMENT: 'contract_management',
  CONTRACT_CREATION: 'contract_creation',
  CONTRACT_CONFIRMATION: 'contract_confirmation',
  CONTRACT_MODIFY: 'contract_confirmation',
  INQUIRY: 'inquiry',
  BILL_MANAGEMENT: 'bill_management',
  BILL_MANAGEMENT_LIST: 'bill_management_list',
  BILL_REGISTRATION: 'bill_registration',
  BILL_DETAILS: 'bill_details',
  MANIFEST_MANAGEMENT: 'manifest_management',
  MANIFEST_DETAILS: 'manifest_details',
  MASTER_ADMIN: 'master_admin',
  ACCOUNT_MASTER: 'account_master',
  WASTE_MASTER: 'waste_master',
  UNIT_OF_MEASURE_MASTER: 'unit_of_measure_master',
  PACKAGING_MASTER: 'packaging_master',
  DISPOSAL_SITE_MASTER: 'disposal_site_master',
  INQUIRY_ADMIN: 'inquiry_admin',
  NEW_REQUEST: 'new_request',
  NEW_REQUEST_LIST: 'new_request_list',
  NEW_QUOTE_REQUEST: 'new_quote_request',
  REGISTER_LARGE_GARBAGE: 'register_large_garbage',
  REGISTER_REGULAR_GARBAGE: 'register_regular_garbage',
  COLLECTION_REQUEST: 'collection_request',
  COLLECTION_REQUEST_CONFIRM: 'collection_request_confirm',
  QUOTATION_REQUEST_CONFIRM: 'quotation_request_confirm',
  NOTICE: 'notice',
  LICENSE_MANAGEMENT: 'license_management',
  ACCOUNT_SELECTION: 'account_selection',
  COLLECTION_AREA_MANAGEMENT: 'collection_area_management',
  BUSINESS_DATE_TIME_SETTINGS: 'business_date_time_settings',
  WASTE_HANDLING_UNIT_PRICE_SETTING: 'waste_handling_unit_price_setting',
  DISPOSAL_UNIT_PRICE_SETTING: 'disposal_unit_price_setting',
  COLLECTION_AREA: 'collection_area',
};

export const API_PREFIX = {
  WASTE: '',
  TRANSPORT: '/trans',
  ADMIN: '/admin'
};

export const ROLE = {
  WASTE: 'WASTE',
  ADMIN: 'ADMIN',
  TRANSPORT: 'TRANSPORT'
};

export const DEFAULT_TRANSPORTER_USER_ID = 20000;
